<script setup>
import {defineProps, defineEmits} from "vue";
import LinhaDeRecebimentos from "./LinhaDeRecebimentos/LinhaDeRecebimentos.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraRecebimento",
]);

//==================================================================//
//==================== Altera Recebimento ==========================//
//==================================================================//

const alteraRecebimento = (update)=>{

    emits('update:alteraRecebimento',update);

};

</script>

<template>

    <div class="c-table__body">

        <LinhaDeRecebimentos v-for="recebimento in props?.dado?.recebimentos"
            :key="recebimento.id"
            :dado="props?.dado"
            :recebimento="recebimento"
            @update:alteraRecebimento="alteraRecebimento"
        ></LinhaDeRecebimentos>

    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>